module.exports = __webpack_public_path__ + "static/media/realtors-card-icon.cb3941c8.svg";